import { createI18n } from 'vue-i18n'
import sr from './cir.json'
import bs from './lat.json'
import en from './en.json'
import cirEkavica from './cir-ekavica.json'
import latEkavica from './lat-ekavica.json'

const savedLang = localStorage.getItem("lang")
const countryId = localStorage.getItem("CountryId")

// Za Srbiju 
const resolvedLang = () => {
  if (savedLang) {
    if (countryId === '3') {
      if (savedLang === 'sr') return 'cir-ekavica'
      if (savedLang === 'bs') return 'lat-ekavica'
    }
    return savedLang
  }
   return 'en'
}

const i18n = createI18n({
  legacy: false,
  locale: resolvedLang(),
  fallbackLocale: "bs",
  messages: {
    sr,
    bs,
    lat: bs,
    en,
    "cir-ekavica": cirEkavica,
    "lat-ekavica": latEkavica,
    cir: sr,
  }
})

export default i18n